import { render, staticRenderFns } from "./SmsShareForm.vue?vue&type=template&id=343a0197"
import script from "./SmsShareForm.vue?vue&type=script&lang=js"
export * from "./SmsShareForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports